/* ==========================================
   Featured Bundle
   AJAX Add To Cart
========================================== */

document.addEventListener("DOMContentLoaded", () => {

  const bundles = document.querySelectorAll(".featured-bundle");

  if (!bundles.length) return;

  bundles.forEach((bundle) => {

    const button = bundle.querySelector(".ajax-featured-cart");
    const popup = bundle.querySelector(".featured-cart-popup");
    const popupTitle = bundle.querySelector(".featured-cart-popup__title");
    const popupClose = bundle.querySelector(".featured-popup-close");

    if (!button || !popup) return;

    /* ===========================
       Update Cart Bubble
    ============================ */

    async function updateCartBubble() {

      try {

        const response = await fetch("/cart.js");
        const cart = await response.json();

        const bubbles = document.querySelectorAll(
          ".cart-count-bubble span, .cart-count, .header__cart-count"
        );

        bubbles.forEach((bubble) => {
          bubble.textContent = cart.item_count;
        });

      } catch (error) {

        console.error(error);

      }

    }

    /* ===========================
       Add To Cart
    ============================ */

    button.addEventListener("click", async () => {

      if (button.classList.contains("loading")) return;

      button.classList.add("loading");

      try {

        const response = await fetch("/cart/add.js", {

          method: "POST",

          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },

          body: JSON.stringify({

            id: button.dataset.variantId,
            quantity: 1

          })

        });

        if (!response.ok) {

          throw new Error("Unable to add product.");

        }

        await response.json();

        button.classList.remove("loading");

        popupTitle.textContent = button.dataset.productTitle;

        popup.classList.add("active");

        updateCartBubble();

      } catch (error) {

        button.classList.remove("loading");

        alert(error.message);

      }

    });

    /* ===========================
       Close Popup Button
    ============================ */

    popupClose.addEventListener("click", () => {

      popup.classList.remove("active");

    });

    /* ===========================
       Click Outside Popup
    ============================ */

    popup.addEventListener("click", (event) => {

      if (event.target === popup) {

        popup.classList.remove("active");

      }

    });

    /* ===========================
       ESC Key
    ============================ */

    document.addEventListener("keydown", (event) => {

      if (event.key === "Escape") {

        popup.classList.remove("active");

      }

    });

  });

});